import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';
import { EPolicyCompany, IPolicyAsset } from 'src/app/modules/shared/models/policy.model';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { INVESTMENT_PREVIDENTIAL_ASSETS_TABLE_TABLE_KEYS, INVESTMENT_LIFE_ASSETS_TABLE_TABLE_KEYS } from './branch-switch-investment-intesa.constants';
import { PolicyService } from 'src/app/modules/policy/policy.service';

@Component({
  selector: 'app-branch-switch-investment-intesa',
  templateUrl: './branch-switch-investment-intesa.component.html',
  styleUrl: './branch-switch-investment-intesa.component.scss',
})
export class BranchSwitchInvestmentIntesaComponent implements OnInit, OnDestroy {

  @Input() assets: IPolicyAsset[] = [];
  @Input() policyFunds: IPolicyAsset[] = [];
  @Input() form: FormGroup;
  @Input() isReadOnly: boolean;
  tableKeys: ITableKey[] = []
  destroy$ = new Subject();

  constructor(private _policyService: PolicyService) {}

  ngOnInit() {
    this.tableKeys = this.isPrevidential ? 
        CommonUtils.assign(INVESTMENT_PREVIDENTIAL_ASSETS_TABLE_TABLE_KEYS) : 
        CommonUtils.assign(INVESTMENT_LIFE_ASSETS_TABLE_TABLE_KEYS);
  }
  
  get showFunds(): boolean {
    return this.assets && this.assets.length > 0;
  }

  get totalDivestmentAmount(): number {
    const value = this.policyFunds.reduce((acc, fund) => {
      let amount = fund?.amount;
      amount = amount.replace(/\./g, '');
      amount = amount.replace(',', '.'); 
      return acc + parseFloat(amount);
    }, 0);
    return value;
  }

  get totalInvestmentAmount(): number {
    const value = this.form?.get('amount')?.value ?? '0,00';
    return value;
  }

  get divestedFunds(): string[] {
    const array = this.policyFunds
      .filter((fund: IPolicyAsset) => fund.fundCode && parseFloat(String(fund.amount)?.replace(',', '.')) > 0)
      .map((fund: IPolicyAsset) => fund.fundCode);
    return array;
  }

  get isPrevidential(): boolean {
    return EPolicyCompany.ISP.includes(this._policyService.companyId);
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
